import { Spacing } from '@persona-id/design-tokens';
import { CircleInfoIcon } from '@persona-id/design-tokens/icons';
import styled from 'styled-components';

import GraphReadOnlyQuery from 'dashboard/components/GraphReadOnlyQuery';
import { AccountStatus } from 'dashboard/models/account-status';
import { Graph } from 'dashboard/models/graph';
import { GraphQuery } from 'dashboard/models/graph-query';
import { GraphQueryTemplate } from 'dashboard/models/graph-query-template';
import Tooltip from 'design-system/components/Tooltip';
import { BASE } from 'design-system/variables/spacing';

const Pill = styled.span`
  margin: ${BASE / 4}px 0 0 ${Spacing[2]};
  padding-left: ${Spacing[1]};
  padding-right: ${Spacing[1]};
  padding-bottom: 2px;
  padding-top: 2px;
  max-width: 100%;
  height: fit-content;
`;

const StyledInfoIcon = styled(CircleInfoIcon)`
  box-sizing: content-box;
`;

interface QueryDefinitionProps {
  accountStatuses: AccountStatus[];
  graph: Graph;
  graphQueryOrTemplate: GraphQuery | GraphQueryTemplate;
}

const QueryDefinition = ({
  accountStatuses,
  graph,
  graphQueryOrTemplate,
}: QueryDefinitionProps) => {
  if (!graphQueryOrTemplate) {
    return null;
  }

  return (
    <>
      <Tooltip
        iconTrigger={
          <Pill>
            <StyledInfoIcon />
          </Pill>
        }
        portal={false}
        side='bottom'
        align='start'
      >
        <GraphReadOnlyQuery
          accountStatuses={accountStatuses.map((accountStatus) => {
            return {
              name: accountStatus.attributes.name,
              token: accountStatus.id,
            };
          })}
          graph={graph}
          query={graphQueryOrTemplate}
        />
      </Tooltip>
    </>
  );
};

export default QueryDefinition;
